import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import styles from './styles.css'

class Select extends Component {
  static propTypes = {
    className: PropTypes.string,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.any.isRequired,
        disabled: PropTypes.bool,
      }),
    ).isRequired,
    label: PropTypes.node,
    placeholder: PropTypes.string,
    description: PropTypes.node,
    input: PropTypes.object,
    meta: PropTypes.object,
    value: PropTypes.any,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
  }

  static defaultProps = {
    className: '',
    label: null,
    description: null,
    placeholder: '',
    input: {},
    meta: {},
    value: '',
    required: false,
    disabled: false,
  }

  getClassName() {
    const { meta } = this.props

    return classnames(
      styles.root,
      {
        [styles.focused]: meta.active,
        [styles.faulty]: meta.touched && meta.error,
        [styles.required]: this.props.required,
        [styles.disabled]: this.props.disabled,
      },
      this.props.className,
    )
  }

  render() {
    const {
      options,
      label,
      placeholder,
      description,
      input,
      meta,

      ...restProps
    } = this.props

    if ((!options || options.length === 0) && placeholder.length === 0) {
      return null
    }

    return (
      <div className={this.getClassName()}>
        {label && <div className={styles.label}>{label}</div>}

        <select {...input} {...restProps} className={styles.select}>
          {placeholder && (
            <option disabled value="">
              {placeholder}
            </option>
          )}

          {options.map(item => (
            <option
              key={item.value || Math.random()}
              value={item.value}
              disabled={item.disabled}
            >
              {item.label}
            </option>
          ))}
        </select>

        {description && <div className={styles.description}>{description}</div>}

        {meta.touched &&
          meta.error && <div className={styles.error}>{meta.error}</div>}
      </div>
    )
  }
}

export default Select



// WEBPACK FOOTER //
// ../source/components/Select/index.js